import { render, staticRenderFns } from "./general-footer.vue?vue&type=template&id=109afbb6"
import script from "./general-footer.vue?vue&type=script&lang=js"
export * from "./general-footer.vue?vue&type=script&lang=js"
import style0 from "./general-footer.vue?vue&type=style&index=0&id=109afbb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports